// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgRewind: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M22.368 13.655c0 5.704-4.67 10.345-10.41 10.345-5.615 0-10.207-4.442-10.403-9.977a.229.229 0 0 1 .23-.236h2.764c.127 0 .23.102.236.229.19 3.77 3.334 6.777 7.173 6.777 3.961 0 7.183-3.202 7.183-7.138 0-3.903-3.167-7.084-7.082-7.137l-.587.012v3.004c0 .558-.622.89-1.085.58L4.2 5.972a1.046 1.046 0 0 1 .003-1.74L10.389.119a.697.697 0 0 1 1.083.58V3.31h.574c5.7.047 10.322 4.67 10.322 10.345" />
      </g>
    </svg>
  );
};

const Memo = memo(SvgRewind);
export default Memo;
